import axios from "../axios-auth";

export const productionItemService = {
  getProductionItemList,
  saveProductionItem,
  getProductionItemDetail,
  getProductionItemsByStatus,
};

function getProductionItemList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (typeof (searchParams.isAddDetails) == 'boolean') {
    params["isAddDetails"] = searchParams.isAddDetails;
  }

  return axios.get("/auth/production-items", { params });
}

function saveProductionItem(productionItem) {
  if (!productionItem.id) {
    // new productionItem
    return axios.post("/auth/production-item", productionItem);
  } else {
    // edit
    return axios.put("/auth/production-item", productionItem);
  }
}

function getProductionItemDetail(id) {
  return axios.get("/auth/production-item/" + id);
}

function getProductionItemsByStatus(status, isAddDetails) {
  let params = {};

  if (isAddDetails) {
    params["isAddDetails"] = isAddDetails;
  }

  return axios.get("/auth/production-items-by-status/" + status, { params });
}


